/**
 * 설문 답변 상태
 * @enum {string}
 */
export const SURVEY_ANSWER_STATE_TYPE = {
    /** 미신청 */
    NONRESPONSE: 'NONRESPONSE',
    /** 신청안함 */
    DENY: 'DENY',
    /** 신청완료 */
    ANSWER: 'ANSWER'
};

/**
 * 수강신청 응답 타입
 * @enum {string}
 */
export const ANSWER_TYPE = {
    /** 정원내 신청 */
    REGULAR: 'REGULAR',
    /** 예비 신청 */
    RESERVED: 'RESERVED',
};
